import { getUrlParams } from '../../../utils';
import { microViewEndBury } from '../bury';

// 屏幕高度
export default {
  props: {
    // 共浏览了几篇笔记
    num: {
      type: Number,
      default: 0
    },
    levelOne: {
      type: String,
      default: ''
    },
    levelTwo: {
      type: String,
      default: ''
    }
  },
  data() {
    const params = getUrlParams(location.href);
    const {
      source = '',
      uid = '',
      reqType = ''
    } = params || {};
    return {
      uid,
      source,
      dataType: reqType || 'feed'
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.showHandle();
    });
  },
  methods: {
    showHandle() {
      const obDom = this.$refs.endDom;
      if (!obDom) {
        return;
      }

      // 曝光埋点
      this.$io.observe(obDom, () => {
        microViewEndBury({
          dataType: this.dataType,
          num: this.num,
          levelOne: this.levelOne,
          levelTwo: this.levelTwo,
          uid: this.uid,
          source: this.source
        });
      });
    }
  }
};